import React from 'react';
import { AbsenceDetailsModal } from '../../Absences';
import type { TimesheetEntry } from '@/types/timesheet';

export interface AbsenceDetailsDialogProps {
  selectedAbsenceForDetails: TimesheetEntry | null;
  setSelectedAbsenceForDetails: React.Dispatch<React.SetStateAction<TimesheetEntry | null>>;
}

/** Read-only details of an absence-sourced timesheet row. */
export function AbsenceDetailsDialog({
  selectedAbsenceForDetails,
  setSelectedAbsenceForDetails,
}: AbsenceDetailsDialogProps) {
  if (!selectedAbsenceForDetails) return null;

  return (
    <AbsenceDetailsModal
      open={!!selectedAbsenceForDetails}
      onOpenChange={(open) => !open && setSelectedAbsenceForDetails(null)}
      entry={{
        absenceType: selectedAbsenceForDetails.absenceType || 'annual-leave',
        absenceReason: selectedAbsenceForDetails.absenceReason,
        approvedBy: selectedAbsenceForDetails.approvedBy,
        approvedAt: selectedAbsenceForDetails.approvedAt,
        absenceId: selectedAbsenceForDetails.absenceId,
        hours: selectedAbsenceForDetails.hours,
        sourceIntegration: selectedAbsenceForDetails.sourceIntegration,
      }}
    />
  );
}
